import { useEffect, useRef, useState } from "react";
import {
  Button,
  DropZone,
  Flex,
  Text,
  VisuallyHidden,
} from "@aws-amplify/ui-react";
import LocalizedStrings from "react-localization";

const DropZoneInput = ({
  fileSelected,
  onChange,
  acceptedFileTypes = ["*"],
}) => {
  const [file, setFile] = useState([]);
  const hiddenInput = useRef(null);

  const onFilePickerChange = (event) => {
    const { files } = event.target;
    if (!files || files.length === 0) {
      return;
    }
    setFile(files[0]);
  };

  useEffect(() => {
    onChange(file);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file]);

  return (
    <>
      <DropZone
        acceptedFileTypes={acceptedFileTypes}
        onDropComplete={({ acceptedFiles }) => setFile(acceptedFiles[0])}
      >
        <Flex direction="column" alignItems="center">
          <Text>{strings.dragImages}</Text>
          <Button size="small" onClick={() => hiddenInput.current.click()}>
            {strings.selectFile}
          </Button>
          <Text variation="tertiary">{fileSelected?.name ?? fileSelected}</Text>
        </Flex>
        <VisuallyHidden>
          <input
            type="file"
            tabIndex={-1}
            ref={hiddenInput}
            onChange={onFilePickerChange}
            multiple={true}
            accept={acceptedFileTypes.join(",")}
          />
        </VisuallyHidden>
      </DropZone>
    </>
  );
};

const strings = new LocalizedStrings({
  es: {
    dragImages: "Arrastre el archivo aquí o",
    selectFile: "Seleccione un archivo",
  },
});

export default DropZoneInput;
